import styled from "styled-components";

export const AdCopySubTitle = styled.div`
	min-width: 500px;
	padding: 10px 5px;
	border-left: 5px solid #999;
	border-bottom: 1px solid #999;
	margin: 15px 0px;
`;
